import React from "react"
import { Button } from "reactstrap"
import { renderToString } from 'react-dom/server'
import { UserPlus } from "react-feather"
import moment from 'moment'

function convertDateCompare(inputFormat) {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-') + ' ' + [pad(d.getHours()), pad(d.getMinutes())].join(':');
}

function getRealId(eventId) {
    eventId = eventId.toString();
    if (eventId.includes('_generated')) return eventId.split(':')[1];
    return eventId.includes('_') ? eventId.split('_').shift() : eventId;
}

export function isReserved(reservations, ev) {
    var alreadyReserved = false;
    var currentStartDate = convertDateCompare(ev.startDate);

    const evId = getRealId(ev.id);

    if (reservations) {
        reservations.map((reservation) => {
            if (reservation.eventId == evId && currentStartDate == reservation.dateStart) {
                alreadyReserved = reservation;
            }
        })
    }

    return alreadyReserved;
}

export function getAvailability(clubReservations, ev) {
    var currentStartDate = moment(ev.startDate).format('YYYY-MM-DD HH:mm');
    return ev.inscription - (ev.reservation && ev.reservation[currentStartDate] ? ev.reservation[currentStartDate] : 0);
    //return ev.inscription - ev.reservation;
}

export function actionEventRender(eventRecord, type, room, reservations) {
    var clubReservations = room ? room.reservations : null;
    const ev = eventRecord.data;

    console.log(ev);
    console.log(reservations);
    console.log(clubReservations);

    if (eventRecord.startDate < new Date()) {
        return '';
    }

    if (ev && ev.inscription !== undefined && ev.inscription != '' && ev.inscription != null) {

        var alreadyReserved = isReserved(reservations, ev);
        var availablePlace = getAvailability(clubReservations, ev);

        var inscr = ev.inscription - availablePlace;
        var availableString = (inscr > ev.inscription ? ev.inscription : inscr) + '/' +
            ev.inscription + (alreadyReserved ? ' - ' + (alreadyReserved.waitingPosition ? "Pos. " + alreadyReserved.waitingPosition + ' sur L.A.' : 'réservé') : (availablePlace == 0 ? ' - complet' : ''));
        //var availableString = availablePlace > 0 ? availablePlace + '/' + ev.inscription : "Complet";

        var waiting = availablePlace <= 0 && room.waitingList && room.waitingList > 0 && (availablePlace * -1) < room.waitingList;
        return renderToString(
            <div className={`event${type}Container`}>
                {alreadyReserved ? (
                    <Button.Ripple color={alreadyReserved.waitingPosition ? "warning" : "success"} size="sm">
                        {availableString}
                    </Button.Ripple>
                ) : (
                    eventRecord.startDate > new Date() && (availablePlace > 0 || waiting) ? (
                        <Button.Ripple color="primary" size="sm">
                            <UserPlus size={12} style={{ marginRight: 5 }} /> {waiting ? <>{availableString} / LA : {availablePlace * -1} / {room.waitingList}</> : <>{availableString} pl.</>}
                        </Button.Ripple>
                    ) : (
                        <Button.Ripple color="danger" size="sm">
                            Complet
                        </Button.Ripple>
                    )
                )}

            </div>
        );

    }
    return '';
}